import i18next from 'i18next';
import { Condition } from '../../../@types/Condition';
import { Pair } from '../../../@types/Pair';
import ButtonAsLink from '../../../Components/Button/ButtonAsLink';
import HtmlNode from '../../../Components/Extension/HtmlNode';
import { prettyNumber } from '../../../Utils/format';
import { translateCondition } from '../../../Utils/constants';
import { Vehicle } from '../../../@types/Vehicle';

const BUTTON_MILEAGE = 'button-edit-mileage';
const BUTTON_MILEAGE_NODE = `${BUTTON_MILEAGE}-node`;
const BUTTON_CONDITION = 'button-edit-condition';
const BUTTON_CONDITION_NODE = `${BUTTON_CONDITION}-node`;

interface List extends Pair {
  id?: string;
}

interface VehicleDetailsProps {
  vehicle?: Vehicle;
  mileage?: string;
  condition?: Condition;
  onEditMilageAndCondition: () => void;
}

class VehicleDetails extends HtmlNode {
  private readonly props: VehicleDetailsProps;

  constructor(element: HTMLElement | null, props: VehicleDetailsProps) {
    super(element);
    this.props = props;
    this.render();
  }

  render() {
    if (!this.props.vehicle) return;

    const {
      modelYear,
      manufactureYear,
      gearboxType,
      color,
      fuelType,
      chassis,
      segment,
      drivingWheel,
      manufacturer,
      salesName,
    } = this.props.vehicle;
    const list: List[] = [
      {
        key: i18next.t('glossary.modelYear'),
        value: modelYear.toString(),
      },
      {
        key: i18next.t('glossary.manufactureYear'),
        value: manufactureYear.toString(),
      },
      {
        key: i18next.t('glossary.gearbox'),
        value: gearboxType,
      },
      {
        key: i18next.t('glossary.color'),
        value: color,
      },
      {
        key: i18next.t('glossary.fuelType'),
        value: fuelType,
      },
      {
        key: i18next.t('glossary.chassis'),
        value: chassis,
      },
      {
        key: i18next.t('glossary.segment'),
        value: segment,
      },
      {
        key: i18next.t('glossary.drivingWheel'),
        value: drivingWheel,
      },
    ];

    if (this.props.mileage) {
      list.push({
        id: BUTTON_MILEAGE_NODE,
        key: i18next.t('glossary.mileage'),
        value: prettyNumber(parseInt(this.props.mileage, 10), {
          postfix:
            i18next
              .t('glossary.mileageUnit', { count: parseInt(this.props.mileage, 10) })
              .toLowerCase() || undefined,
        }),
      });
    }

    if (this.props.condition) {
      list.push({
        id: BUTTON_CONDITION_NODE,
        key: i18next.t('glossary.condition'),
        value: translateCondition(this.props.condition),
      });
    }

    this.node.innerHTML = `
      <div class="waykevaluation-stack waykevaluation-stack--4">
        <h3 class="waykevaluation-heading waykevaluation-heading--3 waykevaluation-no-margin">${manufacturer} <span class="waykevaluation-text waykevaluation-text--font-light">${salesName}</span></h3>
      </div>
      <div class="waykevaluation-stack waykevaluation-stack--4">
        <ul class="waykevaluation-key-value-list">
          ${list
            .map(
              (kv) =>
                `
              <li class="waykevaluation-key-value-list__item">
                <div class="waykevaluation-key-value-list__key">${kv.key}</div>
                <div class="waykevaluation-key-value-list__value">
                  ${
                    kv.id
                      ? `
                    <div class="waykevaluation-hstack waykevaluation-hstack--inline waykevaluation-hstack--spacing-1 waykevaluation-hstack--valign-center">
                      <div class="waykevaluation-hstack__item">${kv.value}</div>
                      <div class="waykevaluation-hstack__item waykevaluation-hstack__item--no-shrink" id="${kv.id}"></div>
                    </div>`
                      : kv.value
                  }
              </li>
            `
            )
            .join('')}
        </ul>
      </div>
    `;

    if (this.props.mileage) {
      new ButtonAsLink(this.node.querySelector(`#${BUTTON_MILEAGE_NODE}`), {
        id: BUTTON_MILEAGE,
        title: i18next.t('glossary.change'),
        onClick: () => this.props.onEditMilageAndCondition(),
      });
    }

    if (this.props.condition) {
      new ButtonAsLink(this.node.querySelector(`#${BUTTON_CONDITION_NODE}`), {
        id: BUTTON_CONDITION,
        title: i18next.t('glossary.change'),
        onClick: () => this.props.onEditMilageAndCondition(),
      });
    }
  }
}

export default VehicleDetails;
